<template lang="pug">
  el-dropdown(
    trigger='click',
    @visible-change="actionOnDropdownChange"
  )
    .el-dropdown-link
      el-tooltip#tooltip(
        effect='dark',
        content='Notificações',
        placement="bottom",
      )
        .notificacao
          el-badge(
            :value='novasNotificacoes',
            :max="10"
          )
            .fa-stack.fa-lg
              font-awesome-icon(icon="bell", size="2x")
    el-dropdown-menu.drop-down-menu(
      slot='dropdown'
    )
      el-dropdown-item.drop-down-item(
        v-for='notificacao in notificacoes',
        :key='notificacao.id'
      )
        .notificacao-body(:class="[ notificacao.recebedor.notificacaoLida ? 'visualizadas' : 'novas']")
          .header
            .titulo {{ notificacao.titulo }}
            .data {{ notificacao.dataCriacao }}
          p.body {{ notificacao.mensagem }}
      .notificacao-footer
        .load-button(v-if='temMaisNotificacoes')
          a(
            @click='loadMoreNotificacoes',
            v-if='!isLoading'
          ) Carregar mais
          i.el-icon-loading(v-else)
        .end-notificacao(v-else)
          span(v-if="!temMaisNotificacoes && notificacoes.length > 0 && pagina !== 0") Não há mais notificações
          span(v-if="notificacoes.length == 0") Não há notificações
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    usuario: {
      required: true
    }
  },

  data () {
    return {
      isLoading: false,
      notificationTime: 10000,
      novasNotificacoes: 0,
      notificacoes: [],
      pagina: 0,
      temMaisNotificacoes: true,
      TAMANHO_PAGINA: 10,
      total: 0
    }
  },

  created () {
    this.getNovasNotificacoes()
  },

  mounted () {
    this.interval = setInterval(() => {
      this.getNovasNotificacoes()
    }, this.notificationTime)
  },

  beforeDestroy () {
    clearInterval(this.interval)
  },

  methods: {
    ...mapActions({
      findNotificacoes: 'notificacoes/find',
      marcarComoLida: 'notificacoes/marcarComoLida',
      getQuantidadeNaoLidas: 'notificacoes/getQuantidadeNaoLidas'
    }),

    async getNovasNotificacoes () {
      this.novasNotificacoes = await this.getQuantidadeNaoLidas()
    },

    loadMoreNotificacoes () {
      this.pagina++
      this.getNotificacoes()
    },

    async getNotificacoes () {
      this.isLoading = true
      const data = await this.findNotificacoes({ tamanhoPagina: this.TAMANHO_PAGINA, pagina: this.pagina })
      this.notificacoes = this.notificacoes.concat(data.notificacoes)
      this.total = data.total

      this.verificarNovasNotificacoes()
      await this.marcarNotificacoesComoLidas()
      this.isLoading = false
    },

    verificarNovasNotificacoes (data) {
      const quantidadePaginas = this.pagina + 1
      if (quantidadePaginas * this.TAMANHO_PAGINA < this.total) {
        this.temMaisNotificacoes = true
      } else {
        this.temMaisNotificacoes = false
      }
    },

    async marcarNotificacoesComoLidas () {
      const ids = this.notificacoes.slice(this.pagina * this.TAMANHO_PAGINA).map((notificacao) => notificacao.id)
      await this.marcarComoLida(ids)
      await this.getNovasNotificacoes()
    },

    async actionOnDropdownChange (isOpen) {
      if (isOpen) {
        await this.getNotificacoes()
        return
      }
      this.onDropdownClose()
    },

    onDropdownClose () {
      this.notificacoes = []
      this.pagina = 0
    }
  }

}

</script>

<style lang="scss">
.notificacao {
  color: #a7b2bb;
  cursor: pointer;
  padding: 10px;
}

.notificacao:hover {
  color: #009f61;
}

.drop-down-menu {
  padding-top: 0px;
  max-height: 330px;
  width: 400px;
  overflow-y: auto;
  overflow-x: hidden;
}

.drop-down-item {
  cursor: default;
  padding: 0px;

  .visualizadas {
    padding: 0 10px 10px;
    border-bottom: solid 0.5px #ccc;
    background: rgba(0, 0, 0, 0.04);
  }

  .novas {
    padding: 0 10px 10px;
    border-bottom: solid 0.5px #ccc;

    .titulo {
      color: #009c66;
    }
  }
}

.notificacao-footer {
  font-size: 13px;
  display: flex;
  text-align: center;
  padding-top: 10px;

  .load-button {
    width: 100%;
  }

  a {
    cursor: pointer;
  }

  a:hover {
    color: #009f61;
  }

  .end-notificacao {
    width: 100%;
  }
}

.el-badge__content.is-fixed {
  top: 5px;
  right: 25px;
  background-color: #009c66;
}

.notificacao-body {
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .titulo {
      font-weight: bold;
    }

    .titulo:hover {
      color: #009f61;
    }
  }

  .body {
    margin: 0;
    line-height: 1.2;
    font-size: 14px;
  }
}

.notificacao-body.novas:hover {
  p:first-child {
    color: #009f61;
  }
}

ul.el-dropdown-menu.el-popper::-webkit-scrollbar-track {
  background-color: #e8ebef;
}

ul.el-dropdown-menu.el-popper::-webkit-scrollbar {
  width: 4px;
}

ul.el-dropdown-menu.el-popper::-webkit-scrollbar-thumb {
  background-color: #33b281;
}
</style>



// WEBPACK FOOTER //
// src/components/Notificacao.vue